module.exports = __webpack_public_path__ + "static/media/linkedin.baa0af53.svg";